import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { FiscalGroup } from "@shared/models/fiscal-group"
import type { Group, GroupMembership } from "@shared/models/group"
import type Rpc from "cc-frontend/services/rpc"
import { isUpgradedMembership } from "cc-frontend/utils/group"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembership
    group: Group
    fiscalGroup: FiscalGroup | null
  }
}

export default class GroupMembersTableUpgraded extends Component<Signature> {
  @service declare rpc: Rpc

  @tracked isUpgrading = false
  @tracked isHovering = false

  get isUpgraded() {
    return isUpgradedMembership(this.args.fiscalGroup, this.args.row)
  }

  @action
  upgradeDowngrade(e: Event) {
    // This prevents the checkbox from being clicked regardless of the result of this.
    e.preventDefault()
    if (this.isUpgrading === true) return
    this.isUpgrading = true
    this.rpc
      .fiscalgroup_set_member_upgrade_status({
        groupId: this.args.group.id,
        membershipId: this.args.row.id,
        newUpgradeStatus: this.isUpgraded ? "DOWNGRADED" : "UPGRADED",
      })
      .then((response) => {
        if (
          response.responseOk === false &&
          response.result.code === "NO_TEACHER_SEATS_AVAILABLE"
        ) {
          window.alert(
            "Sorry! You need to pay for more upgraded members or downgrade some already upgraded members."
          )
        } else if (
          response.responseOk === false &&
          response.result.code === "FISCAL_GROUP_EXPIRED"
        ) {
          window.alert(
            "Your school is expired! Click 'Manage Payment' to reinstate your subscription and upgrade more teachers."
          )
        }
      })
    later(() => (this.isUpgrading = false), 1000)
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::Upgraded": typeof GroupMembersTableUpgraded
  }
}
